import React, { useState } from "react";
import { api } from "../shared/axiosInstance";
import InviteUserModal from "./InviteUserModal";

const CompanyUsers = ({ users, refreshUsers }) => {
    const [editingUserId, setEditingUserId] = useState(null);
    const [newRole, setNewRole] = useState("");
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);

    // Update User Role
    const handleUpdateRole = async (userId) => {
        try {
            const token = localStorage.getItem("token");
            await api.put(
                `/company/users/${userId}/role`,
                { role: newRole },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setEditingUserId(null);
            refreshUsers();
        } catch (error) {
            console.error("❌ Error updating role:", error.response?.data || error);
        }
    };

    // Remove User from Company
    const handleRemoveUser = async (userId) => {
        try {
            const token = localStorage.getItem("token");
            await api.delete(
                `/company/users/${userId}/remove`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            refreshUsers();
        } catch (error) {
            console.error("❌ Error removing user:", error.response?.data || error);
        }
    };

    return (
        <div className="bg-bluegray p-4 rounded-lg shadow-md">
            <h2 className="text-xl font-bold mb-4">Manage Users</h2>

            {/* Invite User Button */}
            <div className="mb-4">
                <button
                    onClick={() => setIsInviteModalOpen(true)}
                    className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
                >
                    Invite User
                </button>
            </div>

            {/* Users List with Edit & Remove Controls */}
            <div className="mt-6">
                {users.length > 0 ? (
                    <ul className="space-y-2">
                        {users.map((user) => (
                            <li key={user._id} className="bg-deepblue p-3 rounded flex justify-between items-center">
                                <div>
                                    <p className="text-lightblue font-bold">{user.firstName} {user.lastName}</p>
                                    <p className="text-lightgray text-sm">{user.email}</p>
                                    {editingUserId === user._id ? (
                                        <select
                                            value={newRole}
                                            onChange={(e) => setNewRole(e.target.value)}
                                            className="mt-2 p-2 rounded bg-bluegray text-lightgray border border-lightblue"
                                        >
                                            <option value="Recruiter">Recruiter</option>
                                            <option value="Company Admin">Company Admin</option>
                                        </select>
                                    ) : (
                                        <p className="text-lightgray text-sm">Role: {user.role}</p>
                                    )}
                                </div>
                                <div className="flex space-x-2">
                                    {editingUserId === user._id ? (
                                        <button
                                            onClick={() => handleUpdateRole(user._id)}
                                            className="bg-green-500 px-3 py-1 rounded text-white"
                                        >
                                            Save
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => {
                                                setEditingUserId(user._id);
                                                setNewRole(user.role);
                                            }}
                                            className="bg-orange px-3 py-1 rounded text-darkblue"
                                        >
                                            Edit Role
                                        </button>
                                    )}
                                    <button
                                        onClick={() => handleRemoveUser(user._id)}
                                        className="bg-red px-3 py-1 rounded text-white"
                                    >
                                        Remove
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-lightgray">No users found.</p>
                )}
            </div>
            <InviteUserModal
                isOpen={isInviteModalOpen}
                onClose={() => setIsInviteModalOpen(false)}
                onInvite={refreshUsers}
            />
        </div>
    );
};

export default CompanyUsers;
